import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const LoanproductAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		loanproductname: yup.string().required().label($t('loanproductname')),
		loan_type: yup.string().nullable().label($t('loanType')),
		amort_type: yup.string().nullable().label($t('amortType')),
		loanamount: yup.number().nullable().label($t('loanamount')),
		interestrate: yup.number().required().label($t('interestrate')),
		insurancefee: yup.number().nullable().label($t('insurancefee')),
		igst: yup.number().nullable().label($t('igst')),
		cgst: yup.number().nullable().label($t('cgst')),
		sgst: yup.number().nullable().label($t('sgst')),
		paymenttype: yup.string().nullable().label($t('paymenttype')),
		loanterm: yup.number().nullable().label($t('loantermMonthWeekDaysBiWeek')),
		splitloan_firstyear: yup.number().nullable().label($t('splitloanFirstyear')),
		securityfee: yup.number().required().label($t('securityfee')),
		processingfee: yup.number().required().label($t('processingfee'))
	});
	
	//form default values
	const formDefaultValues = {
		loanproductname: '', 
		loan_type: '', 
		amort_type: '', 
		loanamount: '', 
		interestrate: "((0))", 
		insurancefee: '', 
		igst: '', 
		cgst: '', 
		sgst: '', 
		paymenttype: '', 
		loanterm: '', 
		splitloan_firstyear: '', 
		securityfee: "((0))", 
		processingfee: "((0))", 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/loanproduct`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="LoanproductAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewLoanproduct')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loanproductname')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loanproductname"  onChange={formik.handleChange}  value={formik.values.loanproductname}   label={$t('loanproductname')} type="text" placeholder={$t('enterLoanproductname')}        className={inputClassName(formik?.errors?.loanproductname)} />
                                                <ErrorMessage name="loanproductname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loanType')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="loan_type"     optionLabel="label" optionValue="value" value={formik.values.loan_type} onChange={formik.handleChange} options={app.menus.loanType2} label={$t('loanType')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.loan_type)}   />
                                                <ErrorMessage name="loan_type" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('amortType')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="amort_type"     optionLabel="label" optionValue="value" value={formik.values.amort_type} onChange={formik.handleChange} options={app.menus.amortType} label={$t('amortType')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.amort_type)}   />
                                                <ErrorMessage name="amort_type" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loanamount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loanamount"  onChange={formik.handleChange}  value={formik.values.loanamount}   label={$t('loanamount')} type="number" placeholder={$t('enterLoanamount')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.loanamount)} />
                                                <ErrorMessage name="loanamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('interestrate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="interestrate"  onChange={formik.handleChange}  value={formik.values.interestrate}   label={$t('interestrate')} type="number" placeholder={$t('enterInterestrate')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.interestrate)} />
                                                <ErrorMessage name="interestrate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('insurancefee')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="insurancefee"  onChange={formik.handleChange}  value={formik.values.insurancefee}   label={$t('insurancefee')} type="number" placeholder={$t('enterInsurancefee')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.insurancefee)} />
                                                <ErrorMessage name="insurancefee" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('igst')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="igst"  onChange={formik.handleChange}  value={formik.values.igst}   label={$t('igst')} type="number" placeholder={$t('enterIgst')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.igst)} />
                                                <ErrorMessage name="igst" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('cgst')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="cgst"  onChange={formik.handleChange}  value={formik.values.cgst}   label={$t('cgst')} type="number" placeholder={$t('enterCgst')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.cgst)} />
                                                <ErrorMessage name="cgst" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('sgst')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="sgst"  onChange={formik.handleChange}  value={formik.values.sgst}   label={$t('sgst')} type="number" placeholder={$t('enterSgst')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.sgst)} />
                                                <ErrorMessage name="sgst" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('paymenttype')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="paymenttype"     optionLabel="label" optionValue="value" value={formik.values.paymenttype} onChange={formik.handleChange} options={app.menus.paymenttype} label={$t('paymenttype')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.paymenttype)}   />
                                                <ErrorMessage name="paymenttype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loantermMonthWeekDaysBiWeek')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loanterm"  onChange={formik.handleChange}  value={formik.values.loanterm}   label={$t('loantermMonthWeekDaysBiWeek')} type="number" placeholder={$t('enterLoanTerm')}  min={0}  step="any"    className={inputClassName(formik?.errors?.loanterm)} />
                                                <ErrorMessage name="loanterm" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('splitloanFirstyear')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="splitloan_firstyear"  onChange={formik.handleChange}  value={formik.values.splitloan_firstyear}   label={$t('splitloanFirstyear')} type="number" placeholder={$t('enterSplitloanFirstyear')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.splitloan_firstyear)} />
                                                <ErrorMessage name="splitloan_firstyear" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('securityfee')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="securityfee"  onChange={formik.handleChange}  value={formik.values.securityfee}   label={$t('securityfee')} type="number" placeholder={$t('enterSecurityfee')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.securityfee)} />
                                                <ErrorMessage name="securityfee" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('processingfee')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="processingfee"  onChange={formik.handleChange}  value={formik.values.processingfee}   label={$t('processingfee')} type="number" placeholder={$t('enterProcessingfee')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.processingfee)} />
                                                <ErrorMessage name="processingfee" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
LoanproductAddPage.defaultProps = {
	primaryKey: 'loanproductid',
	pageName: 'loanproduct',
	apiPath: 'loanproduct/add',
	routeName: 'loanproductadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default LoanproductAddPage;
